import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrincipalComponent } from "./components/principal/principal.component";
import { CursosComponent } from "./components/cursos/cursos.component";  // Importe o componente específico
import { FormacaoComponent } from "./components/formacao/formacao.component";  // Importe o componente específico

export const routes: Routes = [
  { path: '', redirectTo: '/principal', pathMatch: 'full' },
  { path: 'principal', component: PrincipalComponent },
  { path: 'cursos', component: CursosComponent },  // Use o componente, não o módulo
  { path: 'formacao', component: FormacaoComponent }  // Use o componente, não o módulo
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
